import { Route, Routes, Navigate, Outlet } from "react-router-dom";
import jwt_decode from "jwt-decode";

const PrivateRoute = () => {
  var permissions = "";
  const authToken = localStorage.getItem("auth");
  var decoded = jwt_decode(authToken);
  var userpermisson = decoded.user_permissions;
  var ApplicationPermissions = userpermisson[0].ApplicationPermissions;
  if (ApplicationPermissions !== null && ApplicationPermissions !== undefined) {
    const filteredData = ApplicationPermissions.filter((obj) => {
      return obj.PermissionCode === "LOGIN_BG";
    });
    if (filteredData.length > 0) {
      permissions = filteredData[0].PermissionCode;
    }
  }
  return permissions === "LOGIN_BG" ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;
